import React from "react";
import "./style.scss";
import cn from "classnames";

const Title = ({ text, startQuiz }) => {
  return <h2 className={cn("title", { startQuiz })}>{text}</h2>;
};

export default Title;
